import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { AuditLogMessage } from '@cdw-ae/common-data';
import { AuditLogStrings } from '@cdw-ae/amplified-backend-libraries/client';


import {
  filter,
  map,
  switchMap,
  take,
} from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { combineLatest } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AppUser,
  AuthService,
} from '../../modules/auth/services/auth.service';
import {
  AuditLogEntry,
  AuditLogProductCodes,
} from './auditLog.model';


@Injectable({
  providedIn: 'root'
})
export class AuthAuditLogService {

  private auditLogger = this.acf.httpsCallable('auditLog-recordAuditLog');
  private authService: AuthService;

  private auditLogUrl = environment.urls.services.auditLogs.create;


  constructor(private acf: AngularFireFunctions, private http: HttpClient) {}

  public init(authService: AuthService): void {
    this.authService = authService;
  }

  public addLogEntry(auditLogOptions: AuditLogEntry): void {
    this.authService.appUser$
      .pipe(
        filter(appUser => Boolean(appUser?.profile)),
        take(1),
        map((appUser: AppUser) =>
          (auditLogOptions.productCode === AuditLogProductCodes.TEACHER_REVIEW)?
            {
              customerId: appUser.profile.customerId,
              gId: appUser.gId
            }:
            {
              customerId: appUser.profile.customerId,
              userId: appUser.profile.id,
            }),
        map(auditUserData => {
          const dt = new Date();
          const auditLogMessage: AuditLogMessage = {
            dt,
            area: auditLogOptions.productCode,
            userId: auditUserData.userId ?? auditUserData.gId,
            category: AuditLogStrings.lsp.types[auditLogOptions.typeId].type,
            typeId: auditLogOptions.typeId,
            action: AuditLogStrings.lsp?.types[auditLogOptions.typeId]?.actions[auditLogOptions.actionId]?.action,
            actionId: auditLogOptions.actionId,
            actionData: auditLogOptions.logData ? JSON.stringify(auditLogOptions.logData, null, 2) : null,
          };

          return {
            auditLogMessage,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            auditRecord: this.authService.utf8ToB64(JSON.stringify(Object.assign(auditLogOptions, auditUserData, {timestamp: dt.getTime(), created_on: dt} )))
          };
        }),
        switchMap(({auditLogMessage, auditRecord}) =>
          combineLatest([
            this.auditLogger({auditRecord}),
            this.http.post<any>(this.auditLogUrl, auditLogMessage )
          ])
          )
        ).subscribe(([oldAuditLoggerResponse, newAuditLoggerResponse]: [any, any]) => {
      if(!oldAuditLoggerResponse.success ){
        console.error('Failed to record old audit log');
      }
      if(!newAuditLoggerResponse.success ){
        console.error('Failed to record new audit log');
      }
    });
  }
}
